// src/components/ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

/**
 * ProtectedRoute yang bisa:
 * - ⏳ Tampilkan loading saat `isInitialLoad`
 * - 🔐 Cek login: redirect ke /landing jika tidak login
 * - 🎫 Cek role opsional (misal: admin-only)
 * 
 * Cara pakai:
 * <Route element={<ProtectedRoute requiredRole="admin" />}>
 *   <Route path="/admin" element={<AdminScreen />} />
 * </Route>
 */
const ProtectedRoute = ({ requiredRole, children }) => {
  const { isAuthenticated, userRole, loading, isInitialLoad } = useContext(AuthContext);

  if (loading || isInitialLoad) {
    return <div className="p-6 text-gray-500">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/landing" replace />;
  }

  if (requiredRole && userRole !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children || <Outlet />;
};

export default React.memo(ProtectedRoute);
